import { useContext, useCallback } from 'react';
import { AjaxContext, AppContext, formatListData } from 'commons-ui';
import _get from 'lodash/get';
import { UserReferralCodeData, UserReferralSegmentData } from './types';

const useService = () => {
	const { postData, getData } = useContext(AjaxContext);
	const {
		app: { appName }
	} = useContext(AppContext);

	const requestUpdateUserReferralCode = useCallback((data: UserReferralCodeData) => {
		return postData({
			endpoint: '/marketing/dashboard/referral/updateUserReferralCode',
			body: { ...data },
			queryParams: {
				appName
			}
		});
	}, []);

	const requestUpdateUserReferralSegment = useCallback((data: UserReferralSegmentData) => {
		return postData({
			endpoint: '/marketing/dashboard/referral/updateUserReferralSegment',
			body: { ...data },
			queryParams: {
				appName
			}
		});
	}, []);

	const requestGetReferralSegmentPolicies = useCallback(
		async ({ pageDetails }: { pageDetails: any; sortDetails: any; filterDetails: any }) => {
			const result = await getData({
				endpoint: '/marketing/dashboard/referral/getReferralSegmentPolicies',
				queryParams: {
					appName,
					pageNumber: pageDetails.pageNo,
					limit: pageDetails.pageSize
				}
			});
			const data = _get(result, ['data', 'data'], []);
			const rowCount = _get(result, ['data', 'count'], 0);
			const listData = formatListData(data);
			return { rowCount, data: listData };
		},
		[]
	);

	return {
		requestUpdateUserReferralCode,
		requestUpdateUserReferralSegment,
		requestGetReferralSegmentPolicies
	};
};

export default useService;
